export default "/_nuxt/69e61044d30265a349d38fb2151af877.svg";